<template lang="pug">
.uncertain-order-list-item
  el-table(:data="list")
    el-table-column(label="商品" align="left" min-width="120px")
      template(slot-scope="scope")
        .goods-name
          p {{scope.row.itemTitle}}
          p {{scope.row.bundleNo}}
    el-table-column(label="商品属性" align="center" min-width="90px")
      template(slot-scope="scope")
        .c-9
          p.sku-title 单件重：
            span.c-3 {{ scope.row.pieceWeight / 10000}}{{ pieceWeightUnit | formatWeightUnit }}
          p.sku-title 计量方式：
            span.c-3 {{ scope.row.valuationUnitWay | getValuationUnitWayChn }}
          p.sku-title 仓库：
            span.c-3 {{ warehouseName }}
    el-table-column(label="单价" align="center")
      template(slot-scope="scope")
        template(v-if="scope.row.logisticsPrice || scope.row.processFee || scope.row.storageFee || scope.row.commissionFee || scope.row.promiseInterestSubsidyFee || scope.row.settleAdjustFee")
            p {{ priceWithFees(scope.row) }} 元/{{ pieceWeightUnit | formatWeightUnit }}
              zg-info
                div(slot="content")
                  div 商品单价：{{ scope.row.itemSkuPrice / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}
                  div(v-if='scope.row.logisticsPrice') 胖猫物流费：{{ scope.row.logisticsPrice / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}
                  div(v-if='scope.row.processFee') 加工费：{{ scope.row.processFee / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}
                  div(v-if='scope.row.storageFee') 仓储费：{{ scope.row.storageFee / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}
                  div(v-if='scope.row.commissionFee') 委托物流费：{{ scope.row.commissionFee / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}
                  div(v-if='scope.row.promiseInterestSubsidyFee') 承兑贴息费：{{ scope.row.promiseInterestSubsidyFee / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}
                  div(v-if='scope.row.settleAdjustFee') 结算调差费：{{ scope.row.settleAdjustFee / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}
        template(v-else)
            p {{ scope.row.itemSkuPrice / 100 }} 元/{{ pieceWeightUnit | formatWeightUnit }}

    el-table-column(label="数量" align="center" prop="buyNum")
    el-table-column(label="重量" align="center")
      template(slot-scope="scope")
        p {{scope.row.totalWeight / 10000}}{{ pieceWeightUnit | exUnitToWeight }}
    el-table-column(label="实提数量" align="center")
      template(slot-scope="scope")
        p {{ scope.row.realItemNum }}
    el-table-column(label="实提重量" align="center")
      template(slot-scope="scope")
        p {{ scope.row.realItemWeight / 10000 || 0 }}吨
    el-table-column(label="待申请提货(件)" align="center")
      template(slot-scope="scope")
        p {{ scope.row.remainItemNum }}
    el-table-column(v-if="isAbleEdit" label="操作" align="center" width="120px")
      template(slot-scope="scope")
        div.operation-list
          span.icon
            svg-icon( icon-class="edit" @click="edit(scope.row)")
          //- 已提货不能删除
          span.icon
            svg-icon(icon-class="delete" v-if="!scope.row.realItemNum && !scope.row.realItemWeight" @click="delAssign(scope.row.id)")
  div.c-6.p-tb20.text-right
    span 已指认合计：
    span.c-red.m-l10 数量 {{ totalNum }}
    span.c-red.m-l10 {{ totalWeight | formatWeight }}
    span.m-l5 吨
    span.c-red.m-l15 {{ totalAmount | currencyFormat }}
    span.m-l5 元
</template>

<script>
import ZgInfo from '@/components/zg-info'
export default {
  name: 'UncertainOrderListItem',
  components: {
    ZgInfo
  },
  props: {
    list: {
      type: Array
    },
    totalAmount: {
      type: Number
    },
    totalNum: {
      type: Number
    },
    totalWeight: {
      type: Number
    },
    // 仓库
    warehouseName: {
      type: String
    },
    // 单件重单位
    pieceWeightUnit: {
      type: String
    },
    parentOrderItemId: {
      type: Number
    },
    isAbleEdit: {
      type: Boolean
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    // 删除
    delAssign(assignId) {
      this.$confirm('请确认是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        const { data, success } = await this.$post('trademanager.closedOrderItemForSeller', {
          assignId
        })
        if (success) {
          if (data[0].value) {
            this.refreshData()
            this.$message.success('删除成功')
          } else {
            this.$message.error('删除失败，请稍后再试...')
          }
        }
      })
    },
    edit(orderItem) {
      console.log('orderListItem edit....', orderItem)
      this.$emit('edit', this.parentOrderItemId, orderItem)
    },
    refreshData() {
      this.$emit('refreshData')
    },
    priceWithFees(row) {
      return (
        (row.itemSkuPrice +
          row.logisticsPrice +
          (row.processFee || 0) +
          (row.storageFee || 0) +
          (row.commissionFee || 0) +
          (row.promiseInterestSubsidyFee || 0) +
          (row.settleAdjustFee || 0)) /
        100
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.operation-list {
  .icon {
    margin: 0 5px;
    &:hover {
      color: #efb96f;
    }
  }
}
</style>
